__turbopack_context__.v({
  "changeModel": "upload-asset-module__-aHkqW__changeModel",
  "container": "upload-asset-module__-aHkqW__container",
  "content": "upload-asset-module__-aHkqW__content",
  "form": "upload-asset-module__-aHkqW__form",
  "formContainer": "upload-asset-module__-aHkqW__formContainer",
  "help": "upload-asset-module__-aHkqW__help",
  "helpText": "upload-asset-module__-aHkqW__helpText",
  "helpTextBlock": "upload-asset-module__-aHkqW__helpTextBlock",
  "imagePreview": "upload-asset-module__-aHkqW__imagePreview",
  "infoSection": "upload-asset-module__-aHkqW__infoSection",
  "infoText": "upload-asset-module__-aHkqW__infoText",
  "input": "upload-asset-module__-aHkqW__input",
  "inputFields": "upload-asset-module__-aHkqW__inputFields",
  "inputForm": "upload-asset-module__-aHkqW__inputForm",
  "selectModelType": "upload-asset-module__-aHkqW__selectModelType",
  "title": "upload-asset-module__-aHkqW__title",
  "upload": "upload-asset-module__-aHkqW__upload",
  "uploadContent": "upload-asset-module__-aHkqW__uploadContent",
});
